const StakeHoldersMaxLimit = {
  UsApprover: 15,
  securityChampion: 4,
  CccsApprover: 15,
  NonSovereignApprover: 15,
  pdm: 4,
  devManager: 4,
  defaultMaximumUsers: 4,
};

export {
  StakeHoldersMaxLimit,
};
